import React from "react";

export const FuturisticFrame = () => (
  <>
    <div className="ps-bg" aria-hidden="true" />
    <div className="ps-frame" aria-hidden="true">
      <span className="ps-frame-corner tl" />
      <span className="ps-frame-corner tr" />
      <span className="ps-frame-corner bl" />
      <span className="ps-frame-corner br" />
      <span className="ps-frame-tick l" />
      <span className="ps-frame-tick r" />
    </div>
  </>
);
